import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import './style.scss';

class Error extends Component {
    render () {
        return (
            <div className='error-wrap' style={{display: (this.props.error) ? 'block' : 'none'}}>
                <Alert variant='danger' className='error'>
                    <Alert.Heading className='text-center'>Соединение с сервером потеряно!</Alert.Heading>
                    <p className='error-page text-center'>Попробуйте снова позже.</p>
                </Alert>
            </div>
        )
    }
}

export default connect(
    state => ({
        error: state.error
    }),
    dispatch => ({})
)(Error);